import styled, { css } from "styled-components";


export const FlexContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.direction || 'row'};
    justify-content: ${props => props.justify || 'start'};
    width: ${props => props.width};
    font-family: Calibri, Helvetica, sans-serif;
`
export const WrapperContainer = styled.div`
    padding: 20px 5px;
    width: ${props => props.width || '100%'};
    max-width: ${props => props.maxwidth || '100%'};
    font-family: Calibri, Helvetica, sans-serif;
    hr {
        margin: 20px 0px 0;
        background: #0000001f;
        transition: background .3s, opacity .3s;
        height: .5px;
        border: none;
    }
`
export const HeaderContainer = styled.div`
`
export const BackButtonWrap = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 4px;
    padding: 16px;
    max-width: fit-content;
    img {
        width: 30px;
        height: 30px;
    }
    span {
        font-size: 14px;
        color: #192d6e;
    }
`
export const HeaderTitleWrap = styled.div`
    padding: 16px;
    margin: 20px 0;
    h1 {
        font-size: 1.5rem;
        font-weight: 400;
        letter-spacing: normal;
        line-height: 2rem;
        // padding: 20px 0
    }
`
export const IsnNumberWraper = styled.div`
    font-size: 1rem;
    padding: 10px 16px;
    div {
        display: flex;
    }
    span {
        min-width: 150px;
        display: inline-block;
    }
    .my-10 {
        margin: 10px 0;
    }
`
export const TabWrapper = styled.div`
`
export const Tabs = styled.ul`
    display: flex;
    gap: 15px;
    padding: 0 16px;
    margin: 0;

`
export const TabItem = styled.li`
    list-style: none;
    padding: 13px 0px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.715em;
    transition: background 0.3s;
    cursor: pointer;
    position: relative;
    &.active {
        color: #192d6e;
        border-bottom: 2px solid #192d6e;
    }
    &:focus {
        // box-shadow: 0 0 8px rgba(52, 152, 219, 0.8);
    }
            
    &:focus::after {
        content: "";
        position: absolute;
        width: 200%;
        height: 200%;
        top: 50%;
        left: 50%;
        background: rgba(0, 0, 0, 1);
        border-radius: 50%;
        transform: translate(-50%, -50%) scale(0);
        animation: ripple 10s ease-out forwards;
        pointer-events: none;
    }
    @keyframes ripple {
        to {
            transform: translate(-50%, -50%) scale(2);
            opacity: 0;
        }
    }
`
export const ContentWrapper = styled.div`
padding: 20px 0;
@media screen and (max-width: 1200px) {
padding: 20px;
}
`
export const DescriptionWrapper = styled.div`
display: flex;
flex-wrap: wrap;
gap: 1.5rem;
width: 100%;

@media screen and (min-width: 1200px) {
margin: ${props=> props.margin || '0px'}
}
`
export const DescriptionItem = styled.div`
    font-size: 14px;
    line-height: 1.5;
    background: #f5f5f5 !important;
    padding: 16px;
    width: calc(50% - 3rem);
    display: flex;
    align-items: center;
   ${props => props.height && css`
   height: 100px;`}
    span {
        padding: 0 16px 0 30px;
        display: block;
        @media screen and (max-width: 600px) {
        // padding-right: 40px;
        }
    }
    &.full-width {
        width: 100% !important;
    }
    &.font-bold {
        font-weight: 700;
    }
    @media screen and (max-width: 1500px) {
        width: 100%;
    }
`

export const DownArrowIcon = styled.svg`
  width: 30px;
  height: 30px;
  stroke: #192d6e;
  transform: rotate(90deg);
  cursor: pointer;
`;

export const TableContainer = styled.div`
    // min-height: 600px;
    // max-height: 600px;
    overflow: auto;
    width: 100%;
    border: 1px solid #0000001f;
    table{
        border-collapse: initial;
        border-radius: 4px;
        border-spacing: 0;
        max-width: 100%;
        width: 100%;
        height: 100%;
        // overflow: auto;
        // border: 1px solid #0000001f;
        
        .hide-small {
            @media screen and (max-width: 500px) {
                display: none;
            }
        }
        thead tr th {
            position: sticky;
            top: 0;
            z-index: 1;
            font-weight: 600;
            text-align: left;
            background-color: #192d6e;
            color: #fff;
            font-size: 12px;
            height: 28px;
            padding: 0 16px;
            // border-bottom: 1px solid #0000001f !important;
        }
        tbody tr:not(:last-child)>td, tbody tr:not(:last-child)>th {
        // border-bottom : 1px solid #0000001f;
        }
        th.bold, td.bold {
            font-weight: 700;
        }
        tbody tr {
            background: #fff !important;
            height: 28px;
            td {
                font-size: 13px;
                padding: 7px 16px;
                white-space: nowrap;
                text-align: left;
            }
            th {
                font-size: 12px;
                padding: 7px 16px;
                white-space: nowrap;
                text-align: left;
            }
        }
        tbody tr:nth-child(odd) {
            background: #f5f5f5 !important;
        }
    }
`